<template>
    <div>
        <!-- if hasprudct -->
        <simpleLayout
            v-if="hasProductSelected == false"
            :items_count="all_products.length"
        >
            <template #buttons>
                <button
                    type="button"
                    class="btn btn-success mb-2 mr-2"
                    @click="showProductModal"
                >
                    <i class="mdi mdi-plus mr-1"></i> Add Product
                </button>
                <!-- Export to Excel removed: was Webix-dependent, needs reimplementation for b-table -->
            </template>
            <template #content>
                <productsTable @editProduct="handleProductEdit" @adjustStock="handleStockAdjust" />
            </template>
        </simpleLayout>

        <div v-if="hasProductSelected">
            <productDetails @editProduct="handleProductEdit" />
        </div>

        <productsModal v-if="show_modal" :product_id="edit_id" />
        <stockAdjustmentModal v-if="show_stock_modal" :product_id="stock_adjust_id" />
    </div>
</template>

<script>
import productsModal from "./productsModal.vue";
import productsTable from "./productsTable.vue";
import productDetails from "./productDetails.vue";
import stockAdjustmentModal from "./stockAdjustmentModal.vue";
import simpleLayout from "@/components/layout-templates/simple-layout.vue";
import { productComputed, productMethods } from "@/state/helpers";
export default {
    components: {
        simpleLayout,
        productsModal,
        productsTable,
        //eslint-disable-next-line
        productDetails,
        stockAdjustmentModal,
    },
    data: () => ({
        show_modal: false,
        edit_id: -1,
        show_stock_modal: false,
        stock_adjust_id: -1,
    }),
    computed: {
        ...productComputed,
        hasProductSelected() {
            return this.selected_product_id != -1;
        },
    },
    methods: {
        ...productMethods,
        showProductModal() {
            this.show_modal = true;
            this.$nextTick(() => {
                this.$bvModal.show("productsModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (
                        event.type == "hidden" &&
                        event.componentId == "productsModal"
                    ) {
                        this.show_modal = false;
                        this.edit_id = -1;
                    }
                });
            });
        },
        handleProductEdit(product_id) {
            this.edit_id = product_id;
            this.showProductModal();
        },
        handleStockAdjust(product_id) {
            this.stock_adjust_id = product_id;
            this.show_stock_modal = true;
            this.$nextTick(() => {
                this.$bvModal.show("stockAdjustmentModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (
                        event.type == "hidden" &&
                        event.componentId == "stockAdjustmentModal"
                    ) {
                        this.show_stock_modal = false;
                        this.stock_adjust_id = -1;
                    }
                });
            });
        },
    },
    mounted() {
        if (this.all_products.length == 0) {
            this.getProducts().then(() => {
                //this.ready = true;
            });
        }
    },
};
</script>

<style></style>
